<header-bar title=""></header-bar>
<div class="page-content">
    <section data-id="section-membership" class="<%= currentUser.hasActiveMembershipPlan() ? 'hidden' : '' %>">
        <div class="card" style="background-color: transparent!important;margin-bottom: 0; margin-top: 0;">
            <div class="content" style="margin-bottom: 6px; margin-top: 0">
                <h1 class="pb-4r"><img src="assets/images/youtine-logo-white.svg" class="mx-auto" width="140px"></h1>
                <h1 class="text-white">Wähle dein Abo:</h1>
            </div>
        </div>

        <div class="card card-style">
            <div class="content">
                <input type="text"
                       data-id="input-rabattcode"
                       placeholder="Rabattcode"
                       style="width: 100%; border: none; border-bottom: 1px solid grey; text-transform: uppercase;font-size: 18px!important; text-align: center;font-weight: bold"
                       name="rabattcode" />
            </div>
        </div>

        <div class="card card-style hidden"
             data-type="membership-payment-option"
             data-plan-type="rabatt-startnow"
             data-plan-id="<%= membershipPlans[ 3 ].planId %>">
            <div class="content">
                <div class="d-flex">
                    <div class="pe-1 w-60">
                        <img src="assets/icons/payment/youtine-icon-starter.svg" class="mx-auto" width="80px" />
                    </div>
                    <div class="w-100 pt-1">
                        <h1 class="text-uppercase" style="margin-bottom: 0">START NOW</h1>
                        <h4 class="text-dark" style="margin-bottom: 0">Gratismonat</h4>
                        <small>(ab dem 2. Monat 4,99€/Monat)</small>
                    </div>
                </div>
            </div>
        </div>

        <div class="card card-style hidden"
             data-type="membership-payment-option"
             data-plan-type="rabatt-dayone"
             data-plan-id="<%= membershipPlans[ 4 ].planId %>">
            <div class="content">
                <div class="d-flex">
                    <div class="pe-1 w-60">
                        <img src="assets/icons/payment/youtine-icon-fortgeschritten.svg" class="mx-auto" width="80px" />
                    </div>
                    <div class="w-100 pt-1">
                        <h1 class="text-uppercase" style="margin-bottom: 0">DAY ONE</h1>
                        <h4 class="text-dark" style="margin-bottom: 0">3 Gratismonate</h4>
                        <small>(ab dem 4. Monat 3,99€/Monat)</small>
                    </div>
                </div>
            </div>
        </div>

        <div class="card card-style hidden"
             data-type="membership-payment-option"
             data-plan-type="rabatt-powerup"
             data-plan-id="<%= membershipPlans[ 5 ].planId %>">
            <div class="content">
                <div class="d-flex">
                    <div class="pe-1 w-60">
                        <img src="assets/icons/payment/youtine-icon-profi.svg" class="mx-auto" width="80px" />
                    </div>
                    <div class="w-100 pt-1">
                        <h1 class="text-uppercase" style="margin-bottom: 0">POWER UP</h1>
                        <h4 class="text-dark" style="margin-bottom: 0">6 Gratismonate</h4>
                        <small>(ab dem 7. Monat 2,99€/Monat)</small>
                    </div>
                </div>
            </div>
        </div>

        <div class="card card-style hidden"
             data-type="membership-payment-option"
             data-plan-type="rabatt-meingym"
             data-plan-id="<%= membershipPlans[ 6 ].planId %>">
            <div class="content">
                <div class="d-flex">
                    <div class="pe-1 w-60">
                        <img src="assets/icons/payment/youtine-icon-starter.svg" class="mx-auto" width="80px" />
                    </div>
                    <div class="w-100 pt-1">
                        <h1 class="text-uppercase" style="margin-bottom: 0">MEIN GYM</h1>
                        <h4 class="text-dark" style="margin-bottom: 0">Gratismonat</h4>
                        <small>(ab dem 2. Monat 4,99€/Monat)</small>
                    </div>
                </div>
            </div>
        </div>

        <div class="card card-style"
             data-type="membership-payment-option"
             data-plan-type="normal-monthly"
             data-plan-id="<%= membershipPlans[ 0 ].planId %>">
            <div class="content">
                <div class="d-flex">
                    <div class="pe-1 w-60">
                        <img src="assets/icons/payment/youtine-icon-starter.svg" class="mx-auto" width="80px" />
                    </div>
                    <div class="w-100 pt-1">
                        <h1>STARTER</h1>
                        <h4 class="text-dark">4,99€/Monat</h4>
                    </div>
                </div>
            </div>
        </div>

        <div class="card card-style plan-selected" data-type="membership-payment-option" data-plan-id="<%= membershipPlans[ 1 ].planId %>">
            <div class="content">
                <div class="d-flex">
                    <div class="pe-1 w-60">
                        <img src="assets/icons/payment/youtine-icon-fortgeschritten.svg" class="mx-auto" width="80px" />
                    </div>
                    <div class="w-100 pt-1">
                        <h1 style="margin-bottom: 0;">FORTGESCHRITTEN</h1>
                        <h4 class="text-dark" style="margin-bottom: 0">3,99€/Monat</h4>
                        <small>(11,97€ für 3 Monate*)</small>
                    </div>
                </div>
            </div>
        </div>

        <div class="card card-style" data-type="membership-payment-option" data-plan-id="<%= membershipPlans[ 2 ].planId %>"
             style="margin-bottom: 18px;">
            <div class="content">
                <div class="d-flex">
                    <div class="pe-1 w-60">
                        <img src="assets/icons/payment/youtine-icon-profi.svg" class="mx-auto" width="80px" />
                    </div>
                    <div class="w-100 pt-1">
                        <h1 class="text-uppercase" style="margin-bottom: 0">Profi</h1>
                        <h4 class="text-dark" style="margin-bottom: 0">2,99€/Monat</h4>
                        <small>(17,94€ für 6 Monate*)</small>
                    </div>
                </div>
            </div>
        </div>

        <div class="card" style="background-color: transparent!important;margin-top: 0;">
            <div class="content" style="margin-bottom: 6px; margin-top: 0">
                <p class="font-weight-bolder" style="line-height: 1rem;"><sup>*</sup> Die Gebühr für 3 und 6 Monate wird als Gesamtbetrag abgerechnet.</p>
            </div>
        </div>

        <div id="paypal-button-container-membership" style="padding: 0 16px"></div>
    </section>

    <section data-id="section-motivation" class="<%= currentUser.hasActiveMembershipPlan() ? '' : 'hidden' %>">
        <div class="card" style="background-color: transparent!important;margin-bottom: 0; margin-top: 0;">
            <div class="content" style="margin-bottom: 6px; margin-top: 0">
                <h1 class="pb-4r"><img src="assets/images/youtine-logo-white.svg" class="mx-auto" width="140px"></h1>
                <h1 class="text-white">Wähle deinen Motivationsbeitrag:</h1>
            </div>
        </div>
        <div class="card" style="background-color: transparent!important;margin-bottom: 0; margin-top: 0;">
            <div class="content" style="margin-bottom: 6px; margin-top: 0; line-height: 1rem">
                <p class="font-weight-bolder text-white">Diesen Betrag kannst du zu 100%<sup>*</sup> zurückerstattet bekommen, wenn du deine Routine einhältst.</p>
            </div>
        </div>
        <div class="card" style="background-color: transparent!important;margin-bottom: 0; margin-top: 0;">
            <div class="row">
                <% for ( let pi = 0; pi < motivationPlans.length; pi++ ) { %>
                    <div class="col-4 text-center">
                        <button data-plan-id="<%= motivationPlans[ pi ].planId %>"
                                data-type="motivation-payment-option"
                                type="button"
                                style="margin: auto; width: 70px; padding: 12px 0"
                                class="btn mb-3 mt-1 rounded-xs text-uppercase font-700 btn-shadow-l bg-white text-primary <%= 4 === pi ? 'plan-selected' : '' %>">
                            <%= motivationPlans[ pi ].price %>€
                        </button>
                    </div>
                <% }    %>
            </div>
            <div class="row">
                <div class="col-12">
                    <small class="text-white"><sup>*</sup>siehe AGBs</small>
                </div>
            </div>
        </div>

        <div id="paypal-button-container-motivation" style="padding: 0 16px"></div>
    </section>
</div>
